export const DEFAULT_WEIGHT_MANAGEMENT_TYPE = 'Weight Loss'; // for the following (non onboarding) wm appts

export const ASAP_OPTION_DATE = 'asap';

export const APPROX_WAIT_TIME = '~30 min wait';

export const DEFAULT_FRONT_DESK_TYPE_FOR_WM_UPGRADE = 'Weight management upgrade';

export const SCALE_NAME = 'Withings Body Pro 2 Scale';

export const WITHINGS_BODY_PRO_2_SCALE_PRICE = '199';

export const DEFAULT_SCALE_ADDON_CODE = 'withings-body-pro-2-scale';

export const DUMMY_PRICE_OF_AT_HOME_LABS = '60';

export const DEFAULT_APPOINTMENT_CODE = 'general-medical-care';

export const PRESCRIPTION_REFILL_APPT_CODE = 'prescription-refills';

export const DEFAULT_OPTAVIA_WM_APPT_CODE = 'wm-optavia';

export const DEFAULT_LAB_TESTS_APPT_CODE = 'lab-tests';

export const DEFAULT_WM_APPT_CODE = 'wm';

// Shared by every WM cross-check caller so each sees an in-flight call and doesn't fire a second one.
export const WM_CROSSCHECK_CACHE_KEY = 'wm-crosscheck';

export const DEFAULT_MH_APPT_CODE = 'mh';

export const DEFAULT_WH_APPT_CODE = 'wh-hrt';

export const DEFAULT_WH_HRT_CLUB_APPT_CODE = 'wh-hrt-club';

export const DEFAULT_WH_TESTOSTERONE_APPT_CODE = 'wh-testosterone';

export const DEFAULT_WH_RENEWAL_APPT_CODE = 'wh-hrt-renewal';

export const DEFAULT_MH_RENEWAL_APPT_CODE = 'mh-renewal';

// Men's Health (TRT). Named with the TRT prefix to avoid colliding with Mental Health's `mh` codes above.
export const DEFAULT_TRT_APPT_CODE = 'mens-health-testosterone';

export const DEFAULT_TRT_RENEWAL_APPT_CODE = 'mens-health-testosterone-renewal';

export const DEFAULT_TRT_FOLLOW_UP_APPT_CODE = 'mens-health-testosterone-follow-up';

export const DEFAULT_INITIAL_CARDIOLOGY_APPT_CODE = 'cardiology-initial';

export const DEFAULT_NUTRITION_APPT_CODE = 'nutrition';

export const DEFAULT_DIETITIAN_APPT_CODE = 'dietitian';

export const GOVERNMENT_ID_ERRORS = [
  'InvalidIdPhotoError',
  'NameMatchError',
  'BarcodeMatchError',
  'BirthDateMatchError',
  'PublicPersonaDetectError',
  'ExpiredIdError',
  'UnsupportedIdPhotoError',
  'InvalidIdError'
];

export const SELF_PORTRAIT_ERRORS = ['InvalidUserPhotoError', 'FaceMatchError'];

export const VETERANS_INSURANCE_PROVIDER = 'Veterans Affairs (VA) / TRICARE';

export const MINUTES_TO_MEETING = -30;
